import { render, staticRenderFns } from "./VacancyCandidates.vue?vue&type=template&id=31ac46b4"
import script from "./VacancyCandidates.vue?vue&type=script&lang=js"
export * from "./VacancyCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports